import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=4ec3a061&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=ts"
export * from "./CustomerList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec3a061",
  null
  
)

export default component.exports